import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { ERROR_UI } from "@/constants/testIds";

/**
 * Application-wide error boundary. Renders a friendly Arabic fallback UI
 * with a Retry action that hard-reloads the current route.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log once to console for developers.
    console.error("[Fursalogia] ErrorBoundary caught:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid={ERROR_UI.boundary}
        className="flex min-h-screen items-center justify-center bg-white px-6 py-20 text-gray-900"
      >
        <div className="mx-auto max-w-md text-center">
          <span className="mx-auto mb-5 inline-flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-500">
            <AlertTriangle className="h-5 w-5" strokeWidth={1.75} />
          </span>
          <p className="text-xs font-medium uppercase tracking-wider text-gray-400">
            حدث خطأ غير متوقع
          </p>
          <h1 className="mt-3 text-2xl font-semibold tracking-tight text-gray-900">
            نأسف — حصل شيء غير متوقّع
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            حاولنا استعادة الصفحة تلقائياً ولم ننجح. يمكنك المحاولة مرة أخرى، وإذا
            استمرّت المشكلة أعِد تحميل الصفحة.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            data-testid={ERROR_UI.retry}
            className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-gray-900 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-gray-800"
          >
            <RefreshCw className="h-4 w-4" strokeWidth={1.75} />
            إعادة المحاولة
          </button>
        </div>
      </div>
    );
  }
}
